import React from 'react'
import BaseComponent from '@base/BaseComponent'
import CSS from './index.module.css'
import { IconCodeEmum, Iconfont } from '@src/components'

class GLOrderCoupon extends BaseComponent {
	itemPress() {
		this.props.itemPress && this.props.itemPress()
	}

	render() {
		const style = this.props.style || {}
		const title = this.props.title || '下单送券'
		const tags = this.props.tags || []

		// console.log('========= GLOrderCoupon style', style)

		if (tags.length === 0) {
			return null
		}

		return (
			<div className={CSS.coupon} style={style} onClick={this.itemPress.bind(this)}>
				<p className={CSS.couponTitle}>{title}</p>
				<div className={CSS.couponInner}>
					{tags.map((item, index) => {
						return <p key={index}>{item.tagName || ''}</p>
					})}
				</div>
				<Iconfont
					font={IconCodeEmum.ARROW_RIGHT}
					style={{
						width: '.26rem',
						fontSize: '0.24rem',
						color: '#ABB4B8',
						lineHeight: '.42rem',
					}}
				/>
			</div>
		)
	}
}

export default GLOrderCoupon
